module.exports = __webpack_public_path__ + "static/media/eiffel_tower.991b7ca2.svg";